/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
import * as APITypes from '../API';

type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateUser =
  /* GraphQL */ `subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
  onCreateUser(filter: $filter) {
    id
    firstname
    lastname
    email
    createdAt
    updatedAt
    meetingAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    last_seen
    currentMeetingID
    isTemporary
    owner
    isMock
    teamID
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateUserSubscriptionVariables,
    APITypes.OnCreateUserSubscription
  >;
export const onUpdateUser =
  /* GraphQL */ `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
  onUpdateUser(filter: $filter) {
    id
    firstname
    lastname
    email
    createdAt
    updatedAt
    meetingAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    last_seen
    currentMeetingID
    isTemporary
    owner
    isMock
    teamID
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateUserSubscriptionVariables,
    APITypes.OnUpdateUserSubscription
  >;
export const onDeleteUser =
  /* GraphQL */ `subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
  onDeleteUser(filter: $filter) {
    id
    firstname
    lastname
    email
    createdAt
    updatedAt
    meetingAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    last_seen
    currentMeetingID
    isTemporary
    owner
    isMock
    teamID
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteUserSubscriptionVariables,
    APITypes.OnDeleteUserSubscription
  >;
export const onCreateUserClient = /* GraphQL */ `subscription OnCreateUserClient(
  $filter: ModelSubscriptionUserClientFilterInput
) {
  onCreateUserClient(filter: $filter) {
    id
    owner
    clientID
    client {
      id
      clientName
      createdAt
      updatedAt
      __typename
    }
    userID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserClientSubscriptionVariables,
  APITypes.OnCreateUserClientSubscription
>;
export const onUpdateUserClient = /* GraphQL */ `subscription OnUpdateUserClient(
  $filter: ModelSubscriptionUserClientFilterInput
) {
  onUpdateUserClient(filter: $filter) {
    id
    owner
    clientID
    client {
      id
      clientName
      createdAt
      updatedAt
      __typename
    }
    userID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserClientSubscriptionVariables,
  APITypes.OnUpdateUserClientSubscription
>;
export const onDeleteUserClient = /* GraphQL */ `subscription OnDeleteUserClient(
  $filter: ModelSubscriptionUserClientFilterInput
) {
  onDeleteUserClient(filter: $filter) {
    id
    owner
    clientID
    client {
      id
      clientName
      createdAt
      updatedAt
      __typename
    }
    userID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserClientSubscriptionVariables,
  APITypes.OnDeleteUserClientSubscription
>;
export const onCreateClient =
  /* GraphQL */ `subscription OnCreateClient($filter: ModelSubscriptionClientFilterInput) {
  onCreateClient(filter: $filter) {
    id
    clientName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateClientSubscriptionVariables,
    APITypes.OnCreateClientSubscription
  >;
export const onUpdateClient =
  /* GraphQL */ `subscription OnUpdateClient($filter: ModelSubscriptionClientFilterInput) {
  onUpdateClient(filter: $filter) {
    id
    clientName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateClientSubscriptionVariables,
    APITypes.OnUpdateClientSubscription
  >;
export const onDeleteClient =
  /* GraphQL */ `subscription OnDeleteClient($filter: ModelSubscriptionClientFilterInput) {
  onDeleteClient(filter: $filter) {
    id
    clientName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteClientSubscriptionVariables,
    APITypes.OnDeleteClientSubscription
  >;
export const onCreateTeam =
  /* GraphQL */ `subscription OnCreateTeam($filter: ModelSubscriptionTeamFilterInput) {
  onCreateTeam(filter: $filter) {
    id
    teamName
    members {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateTeamSubscriptionVariables,
    APITypes.OnCreateTeamSubscription
  >;
export const onUpdateTeam =
  /* GraphQL */ `subscription OnUpdateTeam($filter: ModelSubscriptionTeamFilterInput) {
  onUpdateTeam(filter: $filter) {
    id
    teamName
    members {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateTeamSubscriptionVariables,
    APITypes.OnUpdateTeamSubscription
  >;
export const onDeleteTeam =
  /* GraphQL */ `subscription OnDeleteTeam($filter: ModelSubscriptionTeamFilterInput) {
  onDeleteTeam(filter: $filter) {
    id
    teamName
    members {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteTeamSubscriptionVariables,
    APITypes.OnDeleteTeamSubscription
  >;
export const onCreateUserMeetingAccess = /* GraphQL */ `subscription OnCreateUserMeetingAccess(
  $filter: ModelSubscriptionUserMeetingAccessFilterInput
) {
  onCreateUserMeetingAccess(filter: $filter) {
    id
    owner
    userID
    meetingID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserMeetingAccessSubscriptionVariables,
  APITypes.OnCreateUserMeetingAccessSubscription
>;
export const onUpdateUserMeetingAccess = /* GraphQL */ `subscription OnUpdateUserMeetingAccess(
  $filter: ModelSubscriptionUserMeetingAccessFilterInput
) {
  onUpdateUserMeetingAccess(filter: $filter) {
    id
    owner
    userID
    meetingID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserMeetingAccessSubscriptionVariables,
  APITypes.OnUpdateUserMeetingAccessSubscription
>;
export const onDeleteUserMeetingAccess = /* GraphQL */ `subscription OnDeleteUserMeetingAccess(
  $filter: ModelSubscriptionUserMeetingAccessFilterInput
) {
  onDeleteUserMeetingAccess(filter: $filter) {
    id
    owner
    userID
    meetingID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserMeetingAccessSubscriptionVariables,
  APITypes.OnDeleteUserMeetingAccessSubscription
>;
export const onCreateMeeting =
  /* GraphQL */ `subscription OnCreateMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onCreateMeeting(filter: $filter) {
    id
    owner
    name
    caseClusterID
    userMeetingJoins {
      items {
        id
        owner
        userID
        meetingID
        user {
          id
          firstname
          lastname
          email
          createdAt
          updatedAt
          last_seen
          currentMeetingID
          isTemporary
          owner
          isMock
          teamID
          __typename
        }
        isCurrentlyInMeeting
        lastPingDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    hostID
    host {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    hostFullName
    createdAt
    updatedAt
    eventDate
    startDate
    endDate
    eventLocation
    participants {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    userAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    guestUrlCode
    previewCode
    clientIDs
    teamIDs
    currentCase
    currentSlide
    currentAssetID
    caseCluster {
      id
      owner
      name
      cases
      createdAt
      updatedAt
      isMock
      clientIDs
      __typename
    }
    caseStats {
      items {
        id
        owner
        meetingID
        caseId
        assetViews {
          nextToken
          __typename
        }
        slides {
          nextToken
          __typename
        }
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    meetingStats {
      id
      owner
      meetingID
      casePresentationHistory
      version
      amountParticipants
      createdAt
      updatedAt
      __typename
    }
    purchaseOrderNbr
    meetingNotes
    meetingType
    isMock
    isInTesting
    isArchived
    isDemo
    isStreamingHost
    streamUrl
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateMeetingSubscriptionVariables,
    APITypes.OnCreateMeetingSubscription
  >;
export const onUpdateMeeting =
  /* GraphQL */ `subscription OnUpdateMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onUpdateMeeting(filter: $filter) {
    id
    owner
    name
    caseClusterID
    userMeetingJoins {
      items {
        id
        owner
        userID
        meetingID
        user {
          id
          firstname
          lastname
          email
          createdAt
          updatedAt
          last_seen
          currentMeetingID
          isTemporary
          owner
          isMock
          teamID
          __typename
        }
        isCurrentlyInMeeting
        lastPingDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    hostID
    host {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    hostFullName
    createdAt
    updatedAt
    eventDate
    startDate
    endDate
    eventLocation
    participants {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    userAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    guestUrlCode
    previewCode
    clientIDs
    teamIDs
    currentCase
    currentSlide
    currentAssetID
    caseCluster {
      id
      owner
      name
      cases
      createdAt
      updatedAt
      isMock
      clientIDs
      __typename
    }
    caseStats {
      items {
        id
        owner
        meetingID
        caseId
        assetViews {
          nextToken
          __typename
        }
        slides {
          nextToken
          __typename
        }
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    meetingStats {
      id
      owner
      meetingID
      casePresentationHistory
      version
      amountParticipants
      createdAt
      updatedAt
      __typename
    }
    purchaseOrderNbr
    meetingNotes
    meetingType
    isMock
    isInTesting
    isArchived
    isDemo
    isStreamingHost
    streamUrl
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateMeetingSubscriptionVariables,
    APITypes.OnUpdateMeetingSubscription
  >;
export const onDeleteMeeting =
  /* GraphQL */ `subscription OnDeleteMeeting($filter: ModelSubscriptionMeetingFilterInput) {
  onDeleteMeeting(filter: $filter) {
    id
    owner
    name
    caseClusterID
    userMeetingJoins {
      items {
        id
        owner
        userID
        meetingID
        user {
          id
          firstname
          lastname
          email
          createdAt
          updatedAt
          last_seen
          currentMeetingID
          isTemporary
          owner
          isMock
          teamID
          __typename
        }
        isCurrentlyInMeeting
        lastPingDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    hostID
    host {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    hostFullName
    createdAt
    updatedAt
    eventDate
    startDate
    endDate
    eventLocation
    participants {
      items {
        id
        firstname
        lastname
        email
        createdAt
        updatedAt
        meetingAccess {
          nextToken
          __typename
        }
        last_seen
        currentMeetingID
        isTemporary
        owner
        isMock
        teamID
        __typename
      }
      nextToken
      __typename
    }
    userAccess {
      items {
        id
        owner
        userID
        meetingID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    guestUrlCode
    previewCode
    clientIDs
    teamIDs
    currentCase
    currentSlide
    currentAssetID
    caseCluster {
      id
      owner
      name
      cases
      createdAt
      updatedAt
      isMock
      clientIDs
      __typename
    }
    caseStats {
      items {
        id
        owner
        meetingID
        caseId
        assetViews {
          nextToken
          __typename
        }
        slides {
          nextToken
          __typename
        }
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    meetingStats {
      id
      owner
      meetingID
      casePresentationHistory
      version
      amountParticipants
      createdAt
      updatedAt
      __typename
    }
    purchaseOrderNbr
    meetingNotes
    meetingType
    isMock
    isInTesting
    isArchived
    isDemo
    isStreamingHost
    streamUrl
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteMeetingSubscriptionVariables,
    APITypes.OnDeleteMeetingSubscription
  >;
export const onCreateUserMeetingJoin = /* GraphQL */ `subscription OnCreateUserMeetingJoin(
  $filter: ModelSubscriptionUserMeetingJoinFilterInput
) {
  onCreateUserMeetingJoin(filter: $filter) {
    id
    owner
    userID
    meetingID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    isCurrentlyInMeeting
    lastPingDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserMeetingJoinSubscriptionVariables,
  APITypes.OnCreateUserMeetingJoinSubscription
>;
export const onUpdateUserMeetingJoin = /* GraphQL */ `subscription OnUpdateUserMeetingJoin(
  $filter: ModelSubscriptionUserMeetingJoinFilterInput
) {
  onUpdateUserMeetingJoin(filter: $filter) {
    id
    owner
    userID
    meetingID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    isCurrentlyInMeeting
    lastPingDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserMeetingJoinSubscriptionVariables,
  APITypes.OnUpdateUserMeetingJoinSubscription
>;
export const onDeleteUserMeetingJoin = /* GraphQL */ `subscription OnDeleteUserMeetingJoin(
  $filter: ModelSubscriptionUserMeetingJoinFilterInput
) {
  onDeleteUserMeetingJoin(filter: $filter) {
    id
    owner
    userID
    meetingID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    isCurrentlyInMeeting
    lastPingDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserMeetingJoinSubscriptionVariables,
  APITypes.OnDeleteUserMeetingJoinSubscription
>;
export const onCreateAnswer =
  /* GraphQL */ `subscription OnCreateAnswer($filter: ModelSubscriptionAnswerFilterInput) {
  onCreateAnswer(filter: $filter) {
    id
    owner
    questionID
    userID
    meetingID
    answerIndexes
    answerTexts
    createdAt
    updatedAt
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateAnswerSubscriptionVariables,
    APITypes.OnCreateAnswerSubscription
  >;
export const onUpdateAnswer =
  /* GraphQL */ `subscription OnUpdateAnswer($filter: ModelSubscriptionAnswerFilterInput) {
  onUpdateAnswer(filter: $filter) {
    id
    owner
    questionID
    userID
    meetingID
    answerIndexes
    answerTexts
    createdAt
    updatedAt
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateAnswerSubscriptionVariables,
    APITypes.OnUpdateAnswerSubscription
  >;
export const onDeleteAnswer =
  /* GraphQL */ `subscription OnDeleteAnswer($filter: ModelSubscriptionAnswerFilterInput) {
  onDeleteAnswer(filter: $filter) {
    id
    owner
    questionID
    userID
    meetingID
    answerIndexes
    answerTexts
    createdAt
    updatedAt
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteAnswerSubscriptionVariables,
    APITypes.OnDeleteAnswerSubscription
  >;
export const onCreateCaseCluster = /* GraphQL */ `subscription OnCreateCaseCluster(
  $filter: ModelSubscriptionCaseClusterFilterInput
) {
  onCreateCaseCluster(filter: $filter) {
    id
    owner
    name
    cases
    createdAt
    updatedAt
    isMock
    clientIDs
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseClusterSubscriptionVariables,
  APITypes.OnCreateCaseClusterSubscription
>;
export const onUpdateCaseCluster = /* GraphQL */ `subscription OnUpdateCaseCluster(
  $filter: ModelSubscriptionCaseClusterFilterInput
) {
  onUpdateCaseCluster(filter: $filter) {
    id
    owner
    name
    cases
    createdAt
    updatedAt
    isMock
    clientIDs
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseClusterSubscriptionVariables,
  APITypes.OnUpdateCaseClusterSubscription
>;
export const onDeleteCaseCluster = /* GraphQL */ `subscription OnDeleteCaseCluster(
  $filter: ModelSubscriptionCaseClusterFilterInput
) {
  onDeleteCaseCluster(filter: $filter) {
    id
    owner
    name
    cases
    createdAt
    updatedAt
    isMock
    clientIDs
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseClusterSubscriptionVariables,
  APITypes.OnDeleteCaseClusterSubscription
>;
export const onCreateMessage =
  /* GraphQL */ `subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput) {
  onCreateMessage(filter: $filter) {
    id
    owner
    channelID
    author
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateMessageSubscriptionVariables,
    APITypes.OnCreateMessageSubscription
  >;
export const onUpdateMessage =
  /* GraphQL */ `subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput) {
  onUpdateMessage(filter: $filter) {
    id
    owner
    channelID
    author
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateMessageSubscriptionVariables,
    APITypes.OnUpdateMessageSubscription
  >;
export const onDeleteMessage =
  /* GraphQL */ `subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput) {
  onDeleteMessage(filter: $filter) {
    id
    owner
    channelID
    author
    body
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteMessageSubscriptionVariables,
    APITypes.OnDeleteMessageSubscription
  >;
export const onCreateMeetingStats = /* GraphQL */ `subscription OnCreateMeetingStats(
  $filter: ModelSubscriptionMeetingStatsFilterInput
) {
  onCreateMeetingStats(filter: $filter) {
    id
    owner
    meetingID
    casePresentationHistory
    version
    amountParticipants
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMeetingStatsSubscriptionVariables,
  APITypes.OnCreateMeetingStatsSubscription
>;
export const onUpdateMeetingStats = /* GraphQL */ `subscription OnUpdateMeetingStats(
  $filter: ModelSubscriptionMeetingStatsFilterInput
) {
  onUpdateMeetingStats(filter: $filter) {
    id
    owner
    meetingID
    casePresentationHistory
    version
    amountParticipants
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMeetingStatsSubscriptionVariables,
  APITypes.OnUpdateMeetingStatsSubscription
>;
export const onDeleteMeetingStats = /* GraphQL */ `subscription OnDeleteMeetingStats(
  $filter: ModelSubscriptionMeetingStatsFilterInput
) {
  onDeleteMeetingStats(filter: $filter) {
    id
    owner
    meetingID
    casePresentationHistory
    version
    amountParticipants
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMeetingStatsSubscriptionVariables,
  APITypes.OnDeleteMeetingStatsSubscription
>;
export const onCreateCaseStats =
  /* GraphQL */ `subscription OnCreateCaseStats($filter: ModelSubscriptionCaseStatsFilterInput) {
  onCreateCaseStats(filter: $filter) {
    id
    owner
    meetingID
    caseId
    assetViews {
      items {
        id
        owner
        assetId
        userID
        timeWatched
        version
        createdAt
        updatedAt
        caseStatsAssetViewsId
        __typename
      }
      nextToken
      __typename
    }
    slides {
      items {
        id
        owner
        slideId
        time
        version
        createdAt
        updatedAt
        caseStatsSlidesId
        __typename
      }
      nextToken
      __typename
    }
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnCreateCaseStatsSubscriptionVariables,
    APITypes.OnCreateCaseStatsSubscription
  >;
export const onUpdateCaseStats =
  /* GraphQL */ `subscription OnUpdateCaseStats($filter: ModelSubscriptionCaseStatsFilterInput) {
  onUpdateCaseStats(filter: $filter) {
    id
    owner
    meetingID
    caseId
    assetViews {
      items {
        id
        owner
        assetId
        userID
        timeWatched
        version
        createdAt
        updatedAt
        caseStatsAssetViewsId
        __typename
      }
      nextToken
      __typename
    }
    slides {
      items {
        id
        owner
        slideId
        time
        version
        createdAt
        updatedAt
        caseStatsSlidesId
        __typename
      }
      nextToken
      __typename
    }
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnUpdateCaseStatsSubscriptionVariables,
    APITypes.OnUpdateCaseStatsSubscription
  >;
export const onDeleteCaseStats =
  /* GraphQL */ `subscription OnDeleteCaseStats($filter: ModelSubscriptionCaseStatsFilterInput) {
  onDeleteCaseStats(filter: $filter) {
    id
    owner
    meetingID
    caseId
    assetViews {
      items {
        id
        owner
        assetId
        userID
        timeWatched
        version
        createdAt
        updatedAt
        caseStatsAssetViewsId
        __typename
      }
      nextToken
      __typename
    }
    slides {
      items {
        id
        owner
        slideId
        time
        version
        createdAt
        updatedAt
        caseStatsSlidesId
        __typename
      }
      nextToken
      __typename
    }
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
    APITypes.OnDeleteCaseStatsSubscriptionVariables,
    APITypes.OnDeleteCaseStatsSubscription
  >;
export const onCreateCaseAssetView = /* GraphQL */ `subscription OnCreateCaseAssetView(
  $filter: ModelSubscriptionCaseAssetViewFilterInput
) {
  onCreateCaseAssetView(filter: $filter) {
    id
    owner
    assetId
    userID
    timeWatched
    version
    createdAt
    updatedAt
    caseStatsAssetViewsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseAssetViewSubscriptionVariables,
  APITypes.OnCreateCaseAssetViewSubscription
>;
export const onUpdateCaseAssetView = /* GraphQL */ `subscription OnUpdateCaseAssetView(
  $filter: ModelSubscriptionCaseAssetViewFilterInput
) {
  onUpdateCaseAssetView(filter: $filter) {
    id
    owner
    assetId
    userID
    timeWatched
    version
    createdAt
    updatedAt
    caseStatsAssetViewsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseAssetViewSubscriptionVariables,
  APITypes.OnUpdateCaseAssetViewSubscription
>;
export const onDeleteCaseAssetView = /* GraphQL */ `subscription OnDeleteCaseAssetView(
  $filter: ModelSubscriptionCaseAssetViewFilterInput
) {
  onDeleteCaseAssetView(filter: $filter) {
    id
    owner
    assetId
    userID
    timeWatched
    version
    createdAt
    updatedAt
    caseStatsAssetViewsId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseAssetViewSubscriptionVariables,
  APITypes.OnDeleteCaseAssetViewSubscription
>;
export const onCreateCaseSlideStats = /* GraphQL */ `subscription OnCreateCaseSlideStats(
  $filter: ModelSubscriptionCaseSlideStatsFilterInput
) {
  onCreateCaseSlideStats(filter: $filter) {
    id
    owner
    slideId
    time
    version
    createdAt
    updatedAt
    caseStatsSlidesId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCaseSlideStatsSubscriptionVariables,
  APITypes.OnCreateCaseSlideStatsSubscription
>;
export const onUpdateCaseSlideStats = /* GraphQL */ `subscription OnUpdateCaseSlideStats(
  $filter: ModelSubscriptionCaseSlideStatsFilterInput
) {
  onUpdateCaseSlideStats(filter: $filter) {
    id
    owner
    slideId
    time
    version
    createdAt
    updatedAt
    caseStatsSlidesId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCaseSlideStatsSubscriptionVariables,
  APITypes.OnUpdateCaseSlideStatsSubscription
>;
export const onDeleteCaseSlideStats = /* GraphQL */ `subscription OnDeleteCaseSlideStats(
  $filter: ModelSubscriptionCaseSlideStatsFilterInput
) {
  onDeleteCaseSlideStats(filter: $filter) {
    id
    owner
    slideId
    time
    version
    createdAt
    updatedAt
    caseStatsSlidesId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCaseSlideStatsSubscriptionVariables,
  APITypes.OnDeleteCaseSlideStatsSubscription
>;
export const onCreateMeetingNPSScore = /* GraphQL */ `subscription OnCreateMeetingNPSScore(
  $filter: ModelSubscriptionMeetingNPSScoreFilterInput
) {
  onCreateMeetingNPSScore(filter: $filter) {
    id
    owner
    userID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    meetingID
    scores
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMeetingNPSScoreSubscriptionVariables,
  APITypes.OnCreateMeetingNPSScoreSubscription
>;
export const onUpdateMeetingNPSScore = /* GraphQL */ `subscription OnUpdateMeetingNPSScore(
  $filter: ModelSubscriptionMeetingNPSScoreFilterInput
) {
  onUpdateMeetingNPSScore(filter: $filter) {
    id
    owner
    userID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    meetingID
    scores
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMeetingNPSScoreSubscriptionVariables,
  APITypes.OnUpdateMeetingNPSScoreSubscription
>;
export const onDeleteMeetingNPSScore = /* GraphQL */ `subscription OnDeleteMeetingNPSScore(
  $filter: ModelSubscriptionMeetingNPSScoreFilterInput
) {
  onDeleteMeetingNPSScore(filter: $filter) {
    id
    owner
    userID
    user {
      id
      firstname
      lastname
      email
      createdAt
      updatedAt
      meetingAccess {
        items {
          id
          owner
          userID
          meetingID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      last_seen
      currentMeetingID
      isTemporary
      owner
      isMock
      teamID
      __typename
    }
    meetingID
    scores
    version
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMeetingNPSScoreSubscriptionVariables,
  APITypes.OnDeleteMeetingNPSScoreSubscription
>;
export const onCreateAccessLink = /* GraphQL */ `subscription OnCreateAccessLink(
  $filter: ModelSubscriptionAccessLinkFilterInput
) {
  onCreateAccessLink(filter: $filter) {
    id
    purpose
    accessCode
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAccessLinkSubscriptionVariables,
  APITypes.OnCreateAccessLinkSubscription
>;
export const onUpdateAccessLink = /* GraphQL */ `subscription OnUpdateAccessLink(
  $filter: ModelSubscriptionAccessLinkFilterInput
) {
  onUpdateAccessLink(filter: $filter) {
    id
    purpose
    accessCode
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAccessLinkSubscriptionVariables,
  APITypes.OnUpdateAccessLinkSubscription
>;
export const onDeleteAccessLink = /* GraphQL */ `subscription OnDeleteAccessLink(
  $filter: ModelSubscriptionAccessLinkFilterInput
) {
  onDeleteAccessLink(filter: $filter) {
    id
    purpose
    accessCode
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAccessLinkSubscriptionVariables,
  APITypes.OnDeleteAccessLinkSubscription
>;
